const userInfo = {
  namespaced: true,
  state: {
    addressInfo: {
      nameValue: '',
      phoneValue: '',
      textarea: '',
      selectedText: '点击选择'
    }
  },
  mutations: {
    setAddressInfo (state, addressInfo) {
      state.addressInfo = addressInfo
    }
  }
}
export default userInfo
